import PropTypes from 'prop-types'
import React, { useEffect, useState } from 'react'
import ResponsiveImage from 'components/images/responsive-image'
import EditorialArtifacts from 'components/editorial/editorial-artifacts'
import StateStorage from 'lib/state-storage'
import { prepareCategoryReferer } from '../utils'
import getHomepageCtaInfo from '../cta-layout'

const DesktopSlideImages = ({ idx, slide, isActive, isPhone }) => {
  const shop = StateStorage.getShop()
  const language = StateStorage.getLanguage()
  const [imageRatio, setImageRatio] = useState(16 / 9)
  const cta = slide?.attributes?.cta
  const media = slide?.attributes?.media
  const title = slide?.attributes?.title
  const title_info = slide?.attributes?.title_info
  const description = slide?.attributes?.subtitle
  const description_info = slide?.attributes?.subtitle_info
  const isCategoryCta = cta?.kind === 'category'
  const linkAs = isCategoryCta
    ? `/${shop}/${language}/clothes/${cta?.link_rewrite}`
    : `${cta?.value}`
  const linkHref = isCategoryCta
    ? `/category?id=${cta?.value}`
    : `${cta?.value}`
  const artifactsProps = {
    ctas: [
      {
        cta: cta?.title,
        cta_box_color: cta?.info?.[`button-color`],
        cta_caption_color: cta?.info?.[`text-color`],
        cta_info: getHomepageCtaInfo(
          cta?.info,
          Boolean(slide?.relationships?.products?.data?.length),
        ),
        cta_link: linkAs,
        cta_href: linkHref,
        id_cta: 1755,
        is_category_page: isCategoryCta,
        is_landing_page: !isCategoryCta,
        is_link_static: 1,
      },
    ],
    title,
    title_info,
    description,
    description_info,
  }
  const refId = slide?.id

  useEffect(() => {
    if (!isPhone) return undefined

    const updateImageRatio = () => {
      const viewportHeight = window.innerHeight - 60
      const viewportWidth = window.innerWidth
      setImageRatio(viewportHeight / viewportWidth)
    }

    updateImageRatio()
    window.addEventListener('resize', updateImageRatio)

    return () => window.removeEventListener('resize', updateImageRatio)
  }, [isPhone])

  if (!media?.url) {
    return null
  }

  return (
    <React.Fragment>
      <ResponsiveImage
        className="editorial-images-slide-image-background"
        imgRatio={isPhone ? imageRatio : 9 / 16}
        src={media.url}
        lazy
        loading={idx === 0 || isActive ? 'eager' : 'lazy'}
        fetchPriority={idx === 0 ? 'high' : 'auto'}
        alt="slideImage"
      />
      <div className="editorial-artifacts">
        <EditorialArtifacts
          linkToCategoryCaptured={() => {
            prepareCategoryReferer(idx + 1, refId)
          }}
          {...artifactsProps}
          ctas={[]}
        />
      </div>
    </React.Fragment>
  )
}

DesktopSlideImages.propTypes = {
  isActive: PropTypes.bool,
  idx: PropTypes.number.isRequired,
  slide: PropTypes.shape({
    url: PropTypes.string,
    image: PropTypes.string,
    full_image: PropTypes.string,
    full_image_mobile: PropTypes.string,
    relationships: PropTypes.shape({
      products: PropTypes.shape({
        data: PropTypes.arrayOf(PropTypes.shape({})),
      }),
    }),
    attributes: PropTypes.shape({
      cta: PropTypes.shape({
        kind: PropTypes.string,
        title: PropTypes.string,
        value: PropTypes.string,
      }),
      title: PropTypes.string,
      title_info: PropTypes.shape({}),
      subtitle: PropTypes.string,
      subtitle_info: PropTypes.shape({}),
      media: PropTypes.shape({ kind: PropTypes.string, url: PropTypes.string }),
    }),
    id: PropTypes.string,
  }).isRequired,
  isPhone: PropTypes.bool.isRequired,
}

DesktopSlideImages.defaultProps = {
  isActive: false,
}

export default DesktopSlideImages
